import { useParams } from "react-router-dom";
import "./Notice.css";

import Template from "./Template/Template";
import TemplateDetail from "./Template/TemplateDetail";

export default function Notice() {
  const { id } = useParams();

  return (
    <>
      <div className="stdlog-notice-header">
        <h2 className="stdlog-notice-title">공지사항</h2>
      </div>

      {id ? <TemplateDetail /> : <Template />}
    </>
  );
}